import { Sale, SalesSearchParams } from '../types';
import { apiClient } from '../services/api';
import { usePaginatedQuery } from './usePaginatedQuery';

const fetchSalesPage = (params: SalesSearchParams) => apiClient.getSales(params);

/** Server state for the sales history list. */
export const useSales = (
  params: SalesSearchParams,
  enabled: boolean,
  errorFallback: string,
) => usePaginatedQuery<Sale, SalesSearchParams>(
  params,
  fetchSalesPage,
  errorFallback,
  'saleNumber',
  enabled,
  'sales',
);
